/**
 * Backwards-compatibility re-exports.
 *
 * The canonical auth provider is now AuthProvider (server-seeded).
 * This file exists so that the ~60 files importing from
 * "@/contexts/common/AuthContextProvider" continue to work without
 * a mass import rewrite.
 */
export {
  AuthProvider as AuthContextProvider,
  useAuthContext,
  type User,
  type ProductRolesState,
} from "./AuthProvider";
